import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const VehicleType = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['vehicle-type', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let options = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(options)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('vehicle_type_information')}
    tableConfig={{
      key: "id",
      apiPath: "vehicle_type/list",
      allowDelete: {
        visible: true,
        key: "vehicle_type_id",
        apiPath: "vehicle_type/delete",
        paramType: 'body'
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'vehicle_type_code',
          caption: t('vehicle_type_code'),
          allowFiltering: true
        },
        {
          dataField: 'vehicle_type_name',
          caption: t('vehicle_type_name'),
          allowFiltering: true
        },
        {
          dataField: 'weight',
          caption: t('payload_weight'),
        },
        {
          dataField: 'dimension',
          caption: t('load_area'),
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('vehicle_type_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('vehicle_type_code'), value: 'vehicle_type_code' },
          { label: t('vehicle_type_name'), value: 'vehicle_type_name' },
          { label: t('payload_weight'), value: 'weight' },
          { label: t('load_area'), value: 'dimension' },
          { label: t('status'), value: 'status_name' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      vehicle_type_code: "",
      vehicle_type_name: "",
      dimension: "",
      weight: "",
      status: "Y"
    }}
    modalConfig={{
      visible: true,
      title: t('vehicle_type_information'),
      required: ["vehicle_type_name"],
      fieldTypeNumber: [],
      paramName: "vehicle_type_id",
      apiPath: {
        "get": '',
        "post": 'vehicle_type/add',
        "put": 'vehicle_type/update'
      },
      elements: [
        {
          fieldName: "vehicle_type_code",
          label: t('vehicle_type_code'),
          placeholder: t('vehicle_type_code'),
          required: false,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "vehicle_type_name",
          label: t('vehicle_type_name'),
          placeholder: t('vehicle_type_name'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "weight",
          label: t('payload_weight_tons'),
          placeholder: t('payload_weight_tons'),
          required: false,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "dimension",
          label: t('load_area_cubic_meters'),
          placeholder: t('load_area_cubic_meters'),
          required: false,
          inputType: "number",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: optionStatus
        },
        // {
        //   fieldName: "description",
        //   label: "คำอธิบาย",
        //   placeholder: "คำอธิบาย",
        //   required: false,
        //   inputType: "text-area",
        //   rows: 2,
        //   isOneRow: true
        // }
      ]
    }}
  />
}))

export default VehicleType